import { Avatar, type SxProps, type Theme } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useBrandFavicon } from '../../hooks/useBrandFavicon';

interface BrandFaviconProps {
  brandId: string | undefined;
  size?: number;
  highRes?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * Renders the brand's stored favicon in an MUI Avatar. Falls back to a generic
 * Storefront icon while loading or when the brand has no stored favicon.
 * Set `highRes` to fetch the 128px variant (used in report covers).
 */
export function BrandFavicon({ brandId, size = 20, highRes = false, sx }: BrandFaviconProps) {
  const src = useBrandFavicon(brandId, { size: highRes ? 128 : 64 });
  return (
    <Avatar
      src={src || undefined}
      variant="rounded"
      sx={{
        width: size,
        height: size,
        bgcolor: 'action.hover',
        color: 'text.secondary',
        fontSize: size * 0.55,
        ...sx,
      }}
    >
      <StorefrontIcon sx={{ fontSize: size * 0.6 }} />
    </Avatar>
  );
}
